import React from "react"

const IconChevronDown = props => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M4.24763 8.65788C3.88363 8.24288 3.92563 7.61188 4.34263 7.24688C4.75763 6.88388 5.38963 6.92588 5.75363 7.34188L12.0006 14.4809L18.2476 7.34188C18.6116 6.92588 19.2436 6.88388 19.6586 7.24688C19.8856 7.44488 20.0006 7.72088 20.0006 7.99988C20.0006 8.23388 19.9196 8.46888 19.7536 8.65788L12.7536 16.6579C12.5626 16.8759 12.2886 16.9999 12.0006 16.9999C11.7126 16.9999 11.4376 16.8759 11.2476 16.6579L4.24763 8.65788Z" fill="currentColor" />
  </svg>
)

export default IconChevronDown
